/**
 * @private
 */
export class SpriteConst {
    /** @private */
    static ALPHA: number = 0x01;
    /** @private */
    static TRANSFORM: number = 0x02;
    /** @private */
    static BLEND: number = 0x04;
    /** @private */
    static CANVAS: number = 0x08;
    /** @private */
    static FILTERS: number = 0x10;
    /** @private */
    static MASK: number = 0x20;
    /** @private */
    static CLIP: number = 0x40;
    /** @private */
    static STYLE: number = 0x80;
    /** @private */
    static TEXTURE: number = 0x100;
    /** @private */
    static GRAPHICS: number = 0x200;
    /** @private */
    static LAYAGL3D: number = 0x400;
    /** @private */
    static CUSTOM: number = 0x800;
    /** @private */
    static ONECHILD: number = 0x1000;
    /** @private */
    static HITAREA: number = 0x2000;
    /** @private */
    static CHILDS: number = 0x4000;

    /** @private */
    static REPAINT_NONE: number = 0;
    /** @private */
    static REPAINT_NODE: number = 0x01;
    /** @private */
    static REPAINT_CACHE: number = 0x02;
    /** @private */
    static REPAINT_ALL: number = 0x03;
}


